<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      show-expand
      multi-sort
      :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
    >
      <template v-slot:top>
        <v-container>
          <v-row>
            <v-col
              cols="12" sm="6" md="4"
              class="py-0"
              v-for="(filter, key) in filters.values" :key="key"
            >
              <v-text-field
                :label="filters.labels[key]"
                v-model="filters.values[key]"
                @keyup.enter="getData"
                :append-icon="filters.values[key] ? 'mdi-close' : ''"
                @click:append="filters.values[key]=''; getData()"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12" sm="6" md="4"
              class="py-0"
            >
              <v-switch
                v-model="filterAutocheck"
                label="Autocheck only"
                @change="getData"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:item.sku="{ item }">
        <router-link :to="{ name: 'ArticlesDetail', params: { id: item.id } }">
          {{ item.sku }}
        </router-link>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="2">
                <v-img
                  class="mx-auto"
                  max-height="200px"
                  max-width="200px"
                  contain
                  :src="item.picture"
                ></v-img>
                <v-switch v-model="item.autocheck" label="Autocheck" @change="updateItem(item['@id'], { autocheck: item.autocheck })"></v-switch>
              </v-col>
              <v-col cols="12" sm="8" md="4">
                <h3>Product details</h3>
                <table>
                  <tr>
                    <td>SKU</td>
                    <td>
                      <router-link :to="{ name: 'ArticlesDetail', params: { id: item.id } }">
                        {{ item.sku }}
                      </router-link>
                    </td>
                  </tr>
                  <tr><td>Manufacturer</td><td>{{ item.manufacturerName }}</td></tr>
                  <tr><td>Part Number</td><td>{{ item.manufacturerPartNumber }}</td></tr>
                  <tr><td>Description</td><td>{{ item.description }}</td></tr>
                  <tr><td>Packaging</td><td>{{ item.packaging }}</td></tr>
                  <tr><td>Product page</td><td><v-btn x-small outlined :href="item.link" target="_blank">open</v-btn></td></tr>
                </table>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <SingleUpdateView
                  :target="item['@id']"
                />
              </v-col>
            </v-row>
          </v-container>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import SingleUpdateView from '@/components/SingleUpdateView.vue'

export default {
  data: () => ({
    headers: [
      { text: 'SKU', value: 'sku' },
      { text: 'Supplier', value: 'supplier.name' },
      { text: 'Manufacturer', value: 'manufacturerName' },
      { text: 'Part Number', value: 'manufacturerPartNumber' },
      { text: 'Packaging', value: 'packaging' },
      { text: 'Details', value: 'data-table-expand' }
    ],
    items: [],
    totalItems: 0,
    loading: true,
    options: {},
    expanded: [],
    filters: {
      labels: {
        'supplier.name': 'Supplier',
        sku: 'SKU',
        manufacturerName: 'Manufacturer',
        manufacturerPartNumber: 'Part Number',
        packaging: 'Packaging'
      },
      values: {
        'supplier.name': '',
        sku: '',
        manufacturerName: '',
        manufacturerPartNumber: '',
        packaging: ''
      }
    },
    filterAutocheck: false
  }),
  components: {
    SingleUpdateView
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },
  methods: {
    getData () {
      this.loading = true
      this.expanded = []
      this.$http(
        this.$directory + '/articles',
        {
          params: {
            page: this.options.page,
            itemsPerPage: this.options.itemsPerPage,
            pagination: this.options.itemsPerPage > 0,
            order: this.options.sortBy.length > 0 ? Object.assign(...this.options.sortBy.map((k, i) => ({ [k]: this.options.sortDesc[i] ? 'desc' : 'asc' }))) : '',
            ...this.filters.values,
            ...{ autocheck: this.filterAutocheck || undefined }
          }
        }
      )
        .then(response => {
          this.items = response.data['hydra:member']
          this.totalItems = response.data['hydra:totalItems']
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateItem (target, data) {
      this.$http.patch(target,
        data,
        {
          headers: {
            'Content-type': 'application/merge-patch+json'
          }
        }
      )
        .finally(() => {
          this.getData()
        })
    }
  }
}
</script>
